<div class="form-group">
  <label for="">{{ nameField }}</label>
  <input type="file" (change)="uploadFile($event)" class="form-control" />
</div>
